import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import queryString from 'query-string'

import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'
import { EloButton } from '@elo-ui/components/elo-button'

import { DEFAULT_FAVICON } from 'constants/general.constants'
import { ACTIVE_PROFILES } from 'constants/profile.constants'

import { getElopageConfig } from 'utils/elopageConfig.utils'
import { setFavicon } from 'utils/dom.utils'
import { profile } from 'utils/profileHelper.utils'

import ProductAccessModal from 'shared/screens/course-preview/ProductAccessModal'

import Default from './themes/Default'
import Custom from './themes/Custom'

//@ts-ignore
import NoCourse from './assets/no_course.svg'

const CoursePreview = observer((props) => {
  const {
    courseSessionsStore,
    courseViewsStore,
    productSessionStore,
    productSlug,
    username,
    lessonId,
    historyPush,
    historyReplace,
    historyGoBack,
    pathname,
    urlParams,
    queryParams,
    LinkComponent,
    preloadedContentPage,
    contentPageStore,
    membershipThemesStore,
    sellerStore,
    sellersStore,
    commentsStore,
    sellerFontsStore,
    payerStore,
    sellablesStore,
    ordersStore,
    currenciesStore,
    quizzesStore,
    lessonsStore,
    communitiesStore,
    communityMemberStore,
  } = props

  const cmpProps = {
    productId: productSlug,
    username,
    lessonId,
    historyPush,
    historyReplace,
    pathname,
    token: urlParams.token,
  }

  const [contentLoaded, setContentLoaded] = useState(false)

  useEffect(() => {
    const isNextApp = getElopageConfig('isNextApp')

    if (isNextApp) {
      courseViewsStore.setCmpProps({
        ...cmpProps,
        historyReplace: (newSearch) => {
          const args = {
            pathname,
            query: {
              ...urlParams,
              ...queryString.parse(newSearch.search),
            },
          }

          historyReplace(args)
        },
      })
      setContentLoaded(true)
    } else {
      courseViewsStore.setSideMenuState(false)
      courseSessionsStore.setExpands(['seller', 'product'])
      courseViewsStore.prepareCourse(cmpProps).then(() => {
        courseViewsStore.setLoading(false)
        setContentLoaded(true)
      })
      courseViewsStore.setBrowserTabTitle()

      return () => {
        const { clearIntervalAccessLimitIntervalId } = productSessionStore
        courseViewsStore.setSideMenuState(true, pathname)
        document.title = courseViewsStore.browserTabTitle
        setFavicon(DEFAULT_FAVICON)
        clearIntervalAccessLimitIntervalId && clearIntervalAccessLimitIntervalId()
      }
    }
  }, [])

  const {
    inited,
    loading,
    lessons,
    viewConfig: { layout },
  } = courseViewsStore

  const ActiveTheme =
    {
      default: Default,
      custom: Custom,
    }[layout] || Default

  const coursePreviewClasses = classNames('course-preview-modal', {
    'course-preview-modal--no-content': !loading && !inited,
  })

  const showNoDataMessage = !loading && !inited && lessons && !lessons.length && contentLoaded
  const isSeller = profile.profileType === ACTIVE_PROFILES.seller
  const isTeamMember = profile.profileType === ACTIVE_PROFILES.teamMember

  return (
    <div className={coursePreviewClasses}>
      {loading && <LoadingMask light />}

      {!loading && inited && (
        <ActiveTheme
          shopName={username}
          cmpProps={cmpProps}
          preloadedContentPage={preloadedContentPage}
          username={username}
          pathname={pathname}
          urlParams={urlParams}
          queryParams={queryParams}
          historyPush={historyPush}
          historyGoBack={historyGoBack}
          LinkComponent={LinkComponent}
          courseViewsStore={courseViewsStore}
          contentPageStore={contentPageStore}
          membershipThemesStore={membershipThemesStore}
          sellerStore={sellerStore}
          sellersStore={sellersStore}
          commentsStore={commentsStore}
          sellerFontsStore={sellerFontsStore}
          payerStore={payerStore}
          sellablesStore={sellablesStore}
          ordersStore={ordersStore}
          currenciesStore={currenciesStore}
          quizzesStore={quizzesStore}
          lessonsStore={lessonsStore}
          communitiesStore={communitiesStore}
          communityMemberStore={communityMemberStore}
        />
      )}

      {showNoDataMessage && (
        <div className='course-preview-modal__no-lessons-message'>
          <div className='course-preview-modal__no-lessons-message-centered'>
            <img src={NoCourse} alt='no course' />
            {(isSeller || isTeamMember) && (
              <>
                <div className='course-preview-modal__no-lessons-message-title'>
                  {I18n.t('react.shared.lessons.cannot_preview')}
                </div>
                <div className='course-preview-modal__no-lessons-message-subtitle'>
                  {I18n.t('react.shared.lessons.cannot_preview_description')}
                </div>
                <EloButton onClick={() => window.open(`/cabinet/products/${productSlug}/edit?step=2`, '_self')}>
                  {I18n.t('react.shared.lessons.back_to_course')}
                </EloButton>
              </>
            )}
            {!isSeller && !isTeamMember && (
              <>
                <div className='course-preview-modal__no-lessons-message-title'>
                  {I18n.t('react.shared.lessons.content_missing')}
                </div>
                <div className='course-preview-modal__no-lessons-message-subtitle'>
                  {I18n.t('react.shared.lessons.content_missing_description')}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <ProductAccessModal username={username} historyPush={historyPush} />
    </div>
  )
})

export default CoursePreview
